import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

const T_TITLE = "Guardar como borrador?";
const T_BODY =
  "Falta la matr" + String.fromCharCode(0xed) + "cula del veh" + String.fromCharCode(0xed) + "culo, que es obligatoria para el DeCA oficial. " +
  "Puedes guardarlo ahora como borrador (el albar" + String.fromCharCode(0xe1) + "n queda reservado) y emitir el documento cuando la tengas.";

export default function ConfirmarBorrador({ open, onOpenChange, onConfirm, busy }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="dialog-borrador">
        <AlertDialogHeader>
          <AlertDialogTitle>{T_TITLE}</AlertDialogTitle>
          <AlertDialogDescription>{T_BODY}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={busy}>Seguir editando</AlertDialogCancel>
          <AlertDialogAction
            className="bg-blue-700 hover:bg-blue-800"
            disabled={busy}
            onClick={(e) => {
              e.preventDefault();
              onConfirm();
            }}
          >
            Guardar borrador
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
